module.exports = __webpack_public_path__ + "img/AIOS.7cd4ed35.png";